import styles from './NoteItem.module.css'
import {ReactNode} from "react";
interface NoteItemPropInt{
    text:string
    children: ReactNode| undefined
    cssClass?: string

}
export default function NoteItem({text,children,cssClass}: NoteItemPropInt)
{
    return(
        <div className={styles.mainCont}>
            {children}
            <div className={[styles.note,cssClass ? cssClass : ""].join(' ')}>{text}</div>
        </div>
    )
}